// Shared API client instances for Admin-dev.
//
// Admin's legacy services hit TWO base URLs:
//   - constant.apiUrl       (.../api/v1/admin) — admin-namespace endpoints
//   - constant.apiHostUrl   (.../api/v1/user)  — user-namespace endpoints (e.g., siteSettings)
//
// We expose one client per base URL so forwarders can pick the right one per call without
// fighting the package's single-baseUrl model. No route normalization is done here —
// paths stay verbatim from the legacy code.
//
// onUnauthorized is intentionally NOT set here. The legacy backend uses an HTTP-200 +
// body.statusCode pattern (so real HTTP 401/403 rarely fire). The forwarder's unwrap()
// helper handles the body.statusCode logout, which is exactly what legacy handleResponse
// did. Adding the client-level hook would extend auto-logout to the bare-axios methods
// (updateMaintenanceMode etc.) which legacy did not have — a behavior change we are
// deliberately avoiding in Phase A.

import axios from 'axios';
import { createClient } from '@crewmates/api-client-legacy';
import constant from '../_config/constant';

export const apiAdminClient = createClient({
  axiosInstance: axios,
  baseUrl: constant.apiUrl,
});

export const apiUserClient = createClient({
  axiosInstance: axios,
  baseUrl: constant.apiHostUrl,
});
